<template>
  <v-card color="primary" dark class="rounded-0" style="position: sticky; bottom:0">
    <v-row no-gutters align="center" class="pr-3">
      <v-col cols="auto" class="hovercol2 d-flex align-self-stretch align-center justify-center" style="width: 48px;"
        @click="clearSelectionMethod()">
        <v-btn icon small>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="auto" class="px-3" style="font-size: 14px; line-height: 1;">
        {{ $t('servicesystem.common_objects.commonterms.selected_items') }}
      </v-col>

      <v-spacer></v-spacer>
      <v-col cols="auto" class="py-2">
        <AltOptionButton :mainAction="{ icon: 'mdi-email-edit', text: 'Send', onClick: () => initiateSend() }"
          :loading="selectLoading" :alternateActions="alternateSelectActions" :color="'primary darken-1'" :top="true">
        </AltOptionButton>
      </v-col>
      <SendEmailDialog :externaltrigger="dialogtrigger" :saveFunction="executeSendEmail" :emailDto="emailDto">
      </SendEmailDialog>
    </v-row>
  </v-card>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import AltOptionButton from "@/views/pim/articles/AltOptionButton.vue";
import SendEmailDialog from "@/components/Dialogs/SendEmailDialog.vue";

export default {
  name: "FileSelectionOptions",
  props: {
    selection: Set,
    clearSelectionMethod: Function,
    refreshListMethod: Function,
    defaultEmailTemplate: Object,
  },
  components: {
    AltOptionButton,
    SendEmailDialog,
  },
  mixins: [clientAPI],

  data() {
    return {
      selectLoading: false,
      dialogtrigger: 1,
      emailDto: null,
    };
  },

  methods: {
    initiateSend() {
      // Exclude external content from email attachments
      var attachments = this.buildDtosFromSelection(true);
      this.emailDto = {
        CustomerId: this.defaultEmailTemplate?.CustomerId || null,
        To: this.defaultEmailTemplate?.To || "",
        Subject: this.defaultEmailTemplate?.Subject || "",
        Body: this.defaultEmailTemplate?.Body || "",
        CC: this.defaultEmailTemplate?.CC || "",
        Attachments: attachments,
      };
      this.dialogtrigger++;
    },

    async executeSendEmail(dto) {
      this.selectLoading = true;
      await this.sendEmail(dto)
        .finally(() => {
          this.clearSelectionMethod();
          this.refreshListMethod();
          this.selectLoading = false;
        })
    },

    buildDtosFromSelection(excludeExternal = false) {
      const dtos = [];
      if (!this.selection) {
        console.log('No documents selected');
        return dtos;
      }

      for (const key of this.selection) {
        const [entityNameRaw, documentTypeIdStr, documentIdStr, isExternalStr] = String(key).split(':');
        if (!entityNameRaw || !documentTypeIdStr || !documentIdStr) continue;
        const isExternal = isExternalStr === '1';
        if (excludeExternal && isExternal) continue; // <-- only filter for email

        // Normalize entity name for job history special-case
        const entityClass = (entityNameRaw === 'MachineJobHistory') ? 'Job' : entityNameRaw;

        dtos.push({
          entityClass,
          documentTypeId: Number(documentTypeIdStr),
          documentId: Number(documentIdStr),
        });
      }
      return dtos;
    },

    async bulkDeleteSelected() {
      console.log('Bulk delete selected');
      const dtos = this.buildDtosFromSelection(false);
      if (!dtos.length) {
        console.log('No documents selected for bulk delete');
        return;
      }
      this.selectLoading = true;
      try {
        await clientAPI.methods.bulkDeleteResources(dtos);
        this.clearSelectionMethod();
        this.refreshListMethod();
      } finally {
        this.selectLoading = false;
      }
    },
  },

  computed: {
    alternateSelectActions() {
      var arr = [
        {
          icon: "mdi-delete",
          text: 'Delete',
          color: "error",
          onClick: () => this.bulkDeleteSelected(),
        },
      ];
      return arr;
    },
  },

  watch: {},
};
</script>